







import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class BaseNotification extends Vue {
  @Prop() message: string
  @Prop({ type: Boolean, default: false }) global: boolean
  @Prop({ type: String, default: 'default' }) type: string

  hidden = false

  hide () {
    this.hidden = true
    this.$emit('close')
  }
}
